@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  colorpass: $color-primary-green;
  colorfail: $color-primary-red;
}
/* stylelint-enable */
